import React, { useEffect, useState } from "react";
import { Bar } from 'react-chartjs-2';
import { useAppSelector } from "../store/store";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchSurvey, fetchSurveyResponses } from "../Firebase/utils";
import { QuestionResponse, QuestionResponseResult, Response, Result, User } from "../types";
import QuestionResponseContainer from "../Components/QuestionResponseContainer";
import SurveyBarChart from "../Components/SurveyBarChart";
import SurveyHistogramChart from "../Components/SurveyHistogramChart";
import ShortResponseResponseDisplay from "../Components/ShortResponseResponseDisplay";
import ShortResponseResultsDisplay from "../Components/ShortResponseResultsDisplay";

const SurveyResults = () => {

    const user = useAppSelector(state => state.user.user);
    const location = useLocation();
    const [ survey, setSurvey ] = useState(useAppSelector(state => state.survey.survey));
    const [ surveyId, setSurveyId ] = useState<string>(location.pathname.split('/')[2]);
    const [ surveyResponses, setSurveyResponses ] = useState<Response[]>([]);
    const navigate = useNavigate();

    const getSurveyResponses = async (surveyId: string) => {
        try{
            const responses = await fetchSurveyResponses(surveyId);
            const responsesArray = responses?.docs.map((doc: any) => {
                return doc.data();
            });
            if(responsesArray){
                setSurveyResponses(responsesArray);
            }
        }catch(err){
            alert(err);
        }
    }

    useEffect(() => {
        surveyId === '' && navigate('/manage-surveys');
            getSurveyResponses(surveyId);
    }, [user]);

    useEffect(() => {
        if(survey.id === ''){
            (async () => {
                fetchSurvey({} as User, surveyId).then((survey) => {
                    setSurvey(survey || {} as any);
                });
            })();
        }
    }, [survey]);


    if(!survey.responses?.length){
        return (
            <div className="flex flex-col justify-center items-center gap-4 w-full h-[80dvh] text-5xl text-white font-BardotBold">
                <h1>No Questions</h1>
                <p className="text-xl text-center">Start adding questions to your Survey to get feedback on the </p>
                <button onClick={() => {
        navigate('/survey-builder');}} className="py-2 px-4 text-2xl border rounded-lg border-[#3d8ae2]">
                    Edit Survey
                </button>
            </div>
            )
    }

    return (
        <div className="flex flex-col justify-center items-center w-full h-full my-8 md:my-10 text-white">
            <h1 className="text-4xl md:text-6xl text-[#3da8e2] font-Velocity tracking-widest text-">{survey.title} Results</h1>
            <section className="flex flex-col gap-4 w-11/12">
            {survey?.responses?.map((response: QuestionResponseResult, index: number) => {
                console.log(response);
                return (
                    <div className="flex flex-col w-full p-1 md:p-5 min-h-48 md:min-h-96 border border-stone-500 rounded-lg md:rounded-3xl shadow-black shadow-md capitalize">
                        <QuestionResponseContainer key={response.questionId} question={response}>
                        {/* <div key={response.questionId} className="flex flex-col w-full p-1 md:p-5 min-h-48 md:min-h-96 border border-stone-500 rounded-lg md:rounded-3xl shadow-black shadow-md capitalize"> */}
                             {['Multiple Choice', 'Multiple Selection', 'Dropdown Selection', 'YesNo'].includes(response.questionType) && <SurveyBarChart
                                        question={response.questionText}
                                        results={response.results as Result[]}
                                    />}
                            {['Scale', 'Rating', ].includes(response.questionType) && <SurveyHistogramChart 
                                question={response.questionText}
                                results={response.results as number[]}
                            />}
                            {['Short Response'].includes(response.questionType) && <ShortResponseResultsDisplay responses={response.results as string[]}/>}
                        {/* </div> */}
                        </QuestionResponseContainer>
                    </div>
                )
            })}
            </section>
        </div>
    );
}

export default SurveyResults;